import classnames from 'classnames';

import { Link } from '@components/Link';

import { CmsBoxListItem } from '@interfaces/common';

import styles from './BoxListItem.module.css';

type BoxListItemProps = Omit<CmsBoxListItem, '_key'>;

export const BoxListItem: React.VFC<BoxListItemProps> = ({
	title,
	description,
	linkText,
	linkUrl,
}) => {
	return (
		<article className={styles.wrapper}>
			<h3 className={classnames(styles.title, 'fluid-font-t6-bold')}>
				{title}
			</h3>
			<p className={classnames(styles.description, 'fluid-font-t5')}>
				{description}
			</p>
			<Link className="fluid-font-t6-bold" href={linkUrl}>
				{linkText}
			</Link>
		</article>
	);
};
